(function () {
  function qs(root, sel) {
    return root.querySelector(sel);
  }

  function qsa(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }

  function escapeHtml(text) {
    var d = document.createElement("div");
    d.textContent = text == null ? "" : String(text);
    return d.innerHTML;
  }

  function parseProductMap(root) {
    var el = qs(root, "[data-ppq-product-map]");
    if (!el || !el.textContent.trim()) {
      return { default: null, itch: null, stress: null, bundle: null };
    }
    try {
      return JSON.parse(el.textContent);
    } catch (err) {
      return { default: null, itch: null, stress: null, bundle: null };
    }
  }

  function parseUspMap(root) {
    var el = qs(root, "[data-ppq-usp-map]");
    if (!el || !el.textContent.trim()) {
      return { skin: [], stress: [] };
    }
    try {
      return JSON.parse(el.textContent);
    } catch (err) {
      return { skin: [], stress: [] };
    }
  }

  function symptomSelectedChips(root) {
    return qsa(root, '[data-ppq-step="1"] .ppq-chip--opt.is-selected');
  }

  function selectedKeySet(root) {
    var o = {};
    symptomSelectedChips(root).forEach(function (c) {
      var k = c.getAttribute("data-ppq-key");
      if (k) o[k] = true;
    });
    return o;
  }

  function selectedCats(root) {
    var t = root.getAttribute("data-ppq-selected-track");
    return { skin: t === "skin", stress: t === "stress" };
  }

  function pickRecommendationSlug(map, root) {
    var track = root.getAttribute("data-ppq-selected-track");
    if (track === "skin" && map.itch) return "itch";
    if (track === "stress" && map.stress) return "stress";
    var fb = firstAvailableProduct(map, ["default", "itch", "stress", "bundle"]);
    return fb.slug;
  }

  function firstAvailableProduct(map, order) {
    for (var i = 0; i < order.length; i++) {
      var key = order[i];
      var p = map[key];
      if (p && p.url) return { slug: key, product: p };
    }
    return { slug: null, product: null };
  }

  function applyRecommendation(root, map) {
    var slug = pickRecommendationSlug(map, root);
    var product = slug && map[slug] && map[slug].url ? map[slug] : null;
    var usedSlug = slug;

    if (!product) {
      var fb = firstAvailableProduct(map, ["default", "itch", "stress", "bundle"]);
      product = fb.product;
      usedSlug = fb.slug;
    }

    var wrap = qs(root, "[data-ppq-result-offer]");
    var block = qs(root, "[data-ppq-result-product]");
    var empty = qs(root, "[data-ppq-result-empty]");
    var img = qs(root, "[data-ppq-result-img]");
    var title = qs(root, "[data-ppq-result-title]");
    var price = qs(root, "[data-ppq-result-price]");
    var cta = qs(root, "[data-ppq-result-cta]");

    if (!wrap || !block) return;

    if (!product || !product.url) {
      root.removeAttribute("data-ppq-rec-slug");
      block.hidden = true;
      if (empty) empty.hidden = false;
      return;
    }

    block.hidden = false;
    if (empty) empty.hidden = true;

    if (img) {
      if (product.image) {
        img.removeAttribute("hidden");
        img.src = product.image;
        img.alt = product.title || "";
      } else {
        img.removeAttribute("src");
        img.setAttribute("hidden", "");
      }
    }
    if (title) title.textContent = product.title || "";
    if (price) price.textContent = product.price || "";
    if (cta) {
      cta.setAttribute("href", product.url);
    }
    if (usedSlug) root.setAttribute("data-ppq-rec-slug", usedSlug);
    else root.removeAttribute("data-ppq-rec-slug");
  }

  var PPQ_POPOVER_MARGIN = 12;
  var PPQ_POPOVER_GAP = 8;

  function resetPopoverPosition(panel) {
    if (!panel) return;
    panel.classList.remove("is-positioned");
    panel.style.position = "";
    panel.style.top = "";
    panel.style.bottom = "";
    panel.style.left = "";
    panel.style.right = "";
    panel.style.width = "";
    panel.style.maxHeight = "";
    panel.style.transform = "";
    panel.removeAttribute("data-ppq-popover-placement");
    panel.removeAttribute("data-ppq-popover-align");
  }

  function positionPopover(panel, btn) {
    if (!panel || !btn) return;

    var anchor =
      btn.closest(".ppq-track-card-shell") ||
      btn.closest(".ppq-track-col") ||
      btn;
    var col = panel.closest("[data-ppq-track-col]");
    var margin = PPQ_POPOVER_MARGIN;
    var gap = PPQ_POPOVER_GAP;
    var viewportW = window.innerWidth;
    var viewportH = window.innerHeight;
    var anchorRect = anchor.getBoundingClientRect();
    var colRect = col ? col.getBoundingClientRect() : anchorRect;

    resetPopoverPosition(panel);
    panel.classList.add("is-positioned");

    var targetWidth = Math.min(
      colRect.width,
      viewportW - margin * 2
    );
    panel.style.width = targetWidth + "px";
    panel.style.maxHeight = Math.min(viewportH * 0.58, 440) + "px";

    var spaceBelow = viewportH - anchorRect.bottom - margin;
    var spaceAbove = anchorRect.top - margin;
    var panelH = panel.offsetHeight;
    var placeAbove =
      panelH > spaceBelow && spaceAbove >= spaceBelow;

    if (placeAbove) {
      panel.setAttribute("data-ppq-popover-placement", "above");
      panel.style.maxHeight = Math.max(120, spaceAbove - gap) + "px";
      panelH = panel.offsetHeight;
      var topAbove = anchorRect.top - gap - panelH;
      if (topAbove < margin) topAbove = margin;
      panel.style.top = topAbove + "px";
      panel.style.bottom = "auto";
    } else {
      panel.setAttribute("data-ppq-popover-placement", "below");
      panel.style.maxHeight = Math.max(120, spaceBelow - gap) + "px";
      panelH = panel.offsetHeight;
      var topBelow = anchorRect.bottom + gap;
      if (topBelow + panelH > viewportH - margin) {
        topBelow = Math.max(margin, viewportH - margin - panelH);
      }
      panel.style.top = topBelow + "px";
      panel.style.bottom = "auto";
    }

    panelH = panel.offsetHeight;
    var panelW = panel.offsetWidth;
    var left = colRect.left;

    if (left + panelW > viewportW - margin) {
      left = viewportW - margin - panelW;
      panel.setAttribute("data-ppq-popover-align", "end");
    }
    if (left < margin) {
      left = margin;
      panel.setAttribute("data-ppq-popover-align", "start");
    }
    if (
      !panel.getAttribute("data-ppq-popover-align") &&
      Math.abs(left - colRect.left) > 2
    ) {
      panel.setAttribute("data-ppq-popover-align", "shift");
    }

    panel.style.left = left + "px";
    panel.style.right = "auto";
  }

  function repositionOpenPopover(overlay) {
    var panel = qs(overlay, "[data-ppq-popover]:not([hidden])");
    if (!panel) return;
    var id = panel.id;
    if (!id) return;
    var btn = qs(overlay, '[data-ppq-info][aria-controls="' + id + '"]');
    if (btn) positionPopover(panel, btn);
  }

  function closePopovers(overlay) {
    qsa(overlay, "[data-ppq-popover]").forEach(function (p) {
      p.setAttribute("hidden", "");
      resetPopoverPosition(p);
    });
    qsa(overlay, "[data-ppq-info]").forEach(function (b) {
      b.setAttribute("aria-expanded", "false");
    });
  }

  function openPopover(overlay, btn, panel) {
    panel.removeAttribute("hidden");
    btn.setAttribute("aria-expanded", "true");
    requestAnimationFrame(function () {
      positionPopover(panel, btn);
      requestAnimationFrame(function () {
        positionPopover(panel, btn);
      });
    });
  }

  function togglePopover(overlay, btn) {
    var id = btn.getAttribute("aria-controls");
    if (!id) return;
    var panel = document.getElementById(id);
    if (!panel) return;
    var willOpen = panel.hasAttribute("hidden");
    closePopovers(overlay);
    if (willOpen) {
      openPopover(overlay, btn, panel);
    }
  }

  function showPopoverForBtn(overlay, btn) {
    var id = btn.getAttribute("aria-controls");
    if (!id) return;
    var panel = document.getElementById(id);
    if (!panel || !overlay.contains(panel)) return;
    qsa(overlay, "[data-ppq-popover]").forEach(function (p) {
      if (p !== panel) {
        p.setAttribute("hidden", "");
        resetPopoverPosition(p);
      }
    });
    qsa(overlay, "[data-ppq-info]").forEach(function (b) {
      if (b !== btn) {
        b.setAttribute("aria-expanded", "false");
      }
    });
    openPopover(overlay, btn, panel);
  }

  function bindPopoverHover(overlay) {
    var mq = window.matchMedia("(hover: hover) and (pointer: fine)");
    if (!mq.matches) return;

    var timers = {};

    function clearT(id) {
      if (timers[id]) {
        clearTimeout(timers[id]);
        timers[id] = null;
      }
    }

    function scheduleClose(id, panel, btn) {
      clearT(id);
      timers[id] = setTimeout(function () {
        panel.setAttribute("hidden", "");
        resetPopoverPosition(panel);
        btn.setAttribute("aria-expanded", "false");
      }, 320);
    }

    qsa(overlay, "[data-ppq-info]").forEach(function (btn) {
      var id = btn.getAttribute("aria-controls");
      if (!id) return;
      var panel = document.getElementById(id);
      if (!panel || !panel.hasAttribute("data-ppq-popover")) return;

      btn.addEventListener("mouseenter", function () {
        clearT(id);
        showPopoverForBtn(overlay, btn);
      });
      btn.addEventListener("mouseleave", function () {
        scheduleClose(id, panel, btn);
      });
      panel.addEventListener("mouseenter", function () {
        clearT(id);
      });
      panel.addEventListener("mouseleave", function () {
        scheduleClose(id, panel, btn);
      });
    });
  }

  function refreshSymptomPanels(root) {
    var track = root.getAttribute("data-ppq-selected-track") || "";
    qsa(root, "[data-ppq-symptom-panel]").forEach(function (panel) {
      var slug = panel.getAttribute("data-ppq-symptom-panel") || "";
      if (slug === track) {
        panel.removeAttribute("hidden");
      } else {
        panel.setAttribute("hidden", "");
      }
    });
    updateTrackUi(root, track);
  }

  function updateTrackUi(root, track) {
    var badge = qs(root, "[data-ppq-track-badge]");
    var title = qs(root, "[data-ppq-step1-title]");
    var label =
      track === "skin"
        ? root.getAttribute("data-ppq-track-label-skin")
        : track === "stress"
          ? root.getAttribute("data-ppq-track-label-stress")
          : "";
    var stepTitle =
      track === "skin"
        ? root.getAttribute("data-ppq-step1-title-skin")
        : track === "stress"
          ? root.getAttribute("data-ppq-step1-title-stress")
          : "";

    if (badge) {
      if (label) {
        badge.textContent = label;
        badge.classList.toggle("is-skin", track === "skin");
        badge.classList.toggle("is-stress", track === "stress");
        badge.removeAttribute("hidden");
      } else {
        badge.setAttribute("hidden", "");
        badge.textContent = "";
      }
    }
    if (title && stepTitle) {
      title.textContent = stepTitle;
    }
  }

  function setSelectedTrack(root, overlay, trackKey) {
    root.setAttribute("data-ppq-selected-track", trackKey);
    qsa(root, "[data-ppq-pick-track]").forEach(function (btn) {
      var slug = btn.getAttribute("data-ppq-pick-track");
      var on = slug === trackKey;
      btn.classList.toggle("is-selected", on);
      btn.setAttribute("aria-pressed", on ? "true" : "false");
    });
    closePopovers(overlay);
    refreshSymptomPanels(root);
  }

  function applyDefaultTrack(root, overlay) {
    var track = root.getAttribute("data-ppq-default-track") || "";
    if (track === "skin" || track === "stress") {
      setSelectedTrack(root, overlay, track);
      return;
    }
    clearTrackSelection(root, overlay);
  }

  function activityLabel(energy) {
    var e = parseInt(energy, 10);
    if (isNaN(e)) return "—";
    if (e <= 33) return "Weinig actief";
    if (e <= 66) return "Actief";
    return "Zeer actief";
  }

  function calcDosage(weightStr) {
    var w = parseFloat(String(weightStr || "").replace(",", "."));
    if (isNaN(w) || w <= 0) {
      return "Raadpleeg de verpakking voor de juiste dosering op basis van het gewicht van je hond.";
    }
    if (w <= 10) return "1 chew per dag (tot 10 kg)";
    if (w <= 20) return "2 chews per dag (10–20 kg)";
    if (w <= 30) return "3 chews per dag (20–30 kg)";
    if (w <= 50) return "4 chews per dag (30–50 kg)";
    return "5 chews per dag (meer dan 50 kg)";
  }

  function formatDateNl() {
    try {
      return new Date().toLocaleDateString("nl-NL", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    } catch (e) {
      return new Date().toISOString().slice(0, 10);
    }
  }

  function trackDisplayLabel(track) {
    if (track === "skin") return "Anti Jeuk";
    if (track === "stress") return "Anti Stress & Angst";
    return "";
  }

  function updateResultUsps(root) {
    var track = root.getAttribute("data-ppq-selected-track") || "";
    var map = parseUspMap(root);
    var items = (map && map[track]) || [];
    var ul = qs(root, "[data-ppq-result-usps]");
    if (!ul) return;
    ul.innerHTML = items
      .filter(Boolean)
      .map(function (text) {
        return (
          '<li><svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><path d="M6.5 12L2 7.5l1.4-1.4L6.5 9.2 12.6 3 14 4.4z"/></svg>' +
          escapeHtml(text) +
          "</li>"
        );
      })
      .join("");
  }

  function clearTrackSelection(root, overlay) {
    root.removeAttribute("data-ppq-selected-track");
    qsa(root, "[data-ppq-pick-track]").forEach(function (btn) {
      btn.classList.remove("is-selected");
      btn.setAttribute("aria-pressed", "false");
    });
    closePopovers(overlay);
    qsa(root, "[data-ppq-symptom-panel]").forEach(function (p) {
      p.setAttribute("hidden", "");
    });
  }

  function clearAllSymptoms(root) {
    qsa(root, '[data-ppq-step="1"] .ppq-chip--opt').forEach(function (c) {
      c.classList.remove("is-selected");
    });
  }

  function resetQuiz(root, overlay, productMap) {
    root.removeAttribute("data-ppq-selected-track");
    root.removeAttribute("data-ppq-rec-slug");
    root.removeAttribute("data-ppq-email-sent");
    clearAllSymptoms(root);
    applyDefaultTrack(root, overlay);

    var nameEl = qs(root, "[data-ppq-dog-name]");
    if (nameEl) nameEl.value = "";

    qsa(root, ".ppq-gender__btn").forEach(function (b, idx) {
      var on = idx === 0;
      b.classList.toggle("is-selected", on);
      b.setAttribute("aria-pressed", on ? "true" : "false");
    });

    var age = qs(root, "[data-ppq-age]");
    if (age) age.value = "";
    var weight = qs(root, "[data-ppq-weight]");
    if (weight) weight.value = "";

    var food = qs(root, "[data-ppq-food]");
    if (food) food.value = "";

    var energy = qs(root, "[data-ppq-energy]");
    if (energy) energy.value = "55";

    qsa(root, ".ppq-env__btn").forEach(function (b, idx) {
      b.classList.toggle("is-selected", idx === 0);
    });

    var fn = qs(root, "[data-ppq-first]");
    var ln = qs(root, "[data-ppq-last]");
    var em = qs(root, "[data-ppq-email]");
    if (fn) fn.value = "";
    if (ln) ln.value = "";
    if (em) em.value = "";

    var emailStatus = qs(root, "[data-ppq-email-status]");
    if (emailStatus) {
      emailStatus.hidden = true;
      emailStatus.textContent = "";
    }

    applyRecommendation(root, productMap);
    var because = qs(root, "[data-ppq-result-because]");
    if (because) because.textContent = because.getAttribute("data-default") || "";
  }

  function collectQuizPayload(root) {
    var track = root.getAttribute("data-ppq-selected-track") || "";
    var trackLabel = trackDisplayLabel(track);

    var symptoms = symptomSelectedChips(root).map(function (c) {
      return c.getAttribute("data-label") || "";
    });
    var symptomKeys = symptomSelectedChips(root).map(function (c) {
      return c.getAttribute("data-ppq-key") || "";
    });

    var dogName = qs(root, "[data-ppq-dog-name]");
    var gBtn = qs(root, ".ppq-gender__btn.is-selected");
    var age = qs(root, "[data-ppq-age]");
    var weight = qs(root, "[data-ppq-weight]");
    var food = qs(root, "[data-ppq-food]");
    var foodLabel = "";
    if (food && food.selectedIndex >= 0) {
      var opt = food.options[food.selectedIndex];
      foodLabel = opt ? opt.textContent.trim() : "";
    }
    var energy = qs(root, "[data-ppq-energy]");
    var envBtn = qs(root, ".ppq-env__btn.is-selected");
    var fn = qs(root, "[data-ppq-first]");
    var ln = qs(root, "[data-ppq-last]");
    var email = qs(root, "[data-ppq-email]");

    var prodTitle = qs(root, "[data-ppq-result-title]");
    var prodPrice = qs(root, "[data-ppq-result-price]");
    var because = qs(root, "[data-ppq-result-because]");

    var titleText =
      prodTitle && prodTitle.textContent ? prodTitle.textContent.trim() : "";
    var priceText =
      prodPrice && prodPrice.textContent ? prodPrice.textContent.trim() : "";
    var becauseText =
      because && because.textContent ? because.textContent.trim() : "";

    if (!titleText || !priceText) {
      var pmap = parseProductMap(root);
      var recSlug = root.getAttribute("data-ppq-rec-slug");
      var rp = recSlug && pmap && pmap[recSlug] ? pmap[recSlug] : null;
      if (rp && typeof rp.title === "string" && rp.title.trim() && !titleText) {
        titleText = rp.title.trim();
      }
      if (
        rp &&
        typeof rp.price === "string" &&
        rp.price.trim() &&
        !priceText
      ) {
        priceText = rp.price.trim();
      }
    }

    return {
      shop: root.getAttribute("data-ppq-shop") || "",
      shopDomain: getShopDomain(),
      submittedAt: new Date().toISOString(),
      pageUrl: typeof window !== "undefined" && window.location ? window.location.href : "",
      track: track,
      trackLabel: trackLabel,
      symptoms: symptoms.filter(Boolean),
      symptomKeys: symptomKeys.filter(Boolean),
      dogName: dogName ? dogName.value.trim() : "",
      gender: gBtn ? gBtn.textContent.replace(/\s+/g, " ").trim() : "",
      age: age ? age.value.trim() : "",
      weight: weight ? weight.value.trim() : "",
      food: foodLabel,
      energy: energy ? energy.value : "",
      activityLevel: activityLabel(energy ? energy.value : ""),
      environment: envBtn ? envBtn.textContent.trim() : "",
      firstName: fn && fn.value ? fn.value.trim() : "",
      lastName: ln && ln.value ? ln.value.trim() : "",
      email: email && email.value ? email.value.trim() : "",
      productTitle: titleText,
      productPrice: priceText,
      recommendationBecause: becauseText,
      recommendationSlug: root.getAttribute("data-ppq-rec-slug") || "",
    };
  }

  function getShopDomain() {
    if (typeof window !== "undefined" && window.Shopify && window.Shopify.shop) {
      return String(window.Shopify.shop);
    }
    return "";
  }

  function postQuizFormData(url, payload, useCors) {
    var headers = {};
    var shopDomain = getShopDomain();
    if (shopDomain) headers["X-Shop-Domain"] = shopDomain;

    var payloadJson = JSON.stringify(payload);

    if (useCors) {
      headers["Content-Type"] = "application/x-www-form-urlencoded;charset=UTF-8";
      return fetch(String(url).trim(), {
        method: "POST",
        mode: "cors",
        body: "payload=" + encodeURIComponent(payloadJson),
        headers: headers,
      });
    }

    var fd = new FormData();
    fd.append("payload", payloadJson);
    return fetch(String(url).trim(), {
      method: "POST",
      mode: "no-cors",
      body: fd,
    });
  }

  function submitQuizData(root, force) {
    if (!force && root.getAttribute("data-ppq-email-sent") === "1") return Promise.resolve();

    var scriptUrl = root.getAttribute("data-ppq-script-url");
    var apiUrl = root.getAttribute("data-ppq-api-url");
    var hasScript = scriptUrl && String(scriptUrl).trim();
    var hasApi = apiUrl && String(apiUrl).trim();
    if (!hasScript && !hasApi) return Promise.resolve();

    var payload = collectQuizPayload(root);

    root.setAttribute("data-ppq-email-sent", "1");

    var tasks = [];
    if (hasScript) {
      tasks.push(
        postQuizFormData(scriptUrl, payload, false).catch(function () {
          return { ok: false, target: "script" };
        })
      );
    }
    if (hasApi) {
      tasks.push(
        postQuizFormData(apiUrl, payload, true).catch(function () {
          return { ok: false, target: "api" };
        })
      );
    }

    return Promise.allSettled(tasks).then(function (results) {
      var anyRejected = results.some(function (r) {
        return r.status === "rejected";
      });
      if (anyRejected) root.removeAttribute("data-ppq-email-sent");
    });
  }

  function buildPrintSummaryHtml(root) {
    var data = collectQuizPayload(root);
    var track = data.track;
    var dogName = data.dogName || "je hond";
    var customerName = (data.firstName + " " + data.lastName).trim() || "—";
    var symptoms = data.symptoms || [];
    var symptomsText = symptoms.length ? symptoms.join(", ") : "—";
    var productTitle = data.productTitle || "—";
    var dosage = calcDosage(data.weight);
    var dateStr = formatDateNl();
    var activity = data.activityLevel || activityLabel(data.energy);

    var becauseText = "";
    if (track === "skin") {
      becauseText =
        "Omdat " +
        dogName +
        " regelmatig last heeft van " +
        symptomsText +
        ", adviseren wij ons Anti Jeuk Supplement. De natuurlijke ingrediënten ondersteunen de huid van binnenuit, helpen de huidbarrière versterken en ondersteunen een gezonde weerstand. Hierdoor kan de huid weer tot rust komen en neemt de behoefte om te krabben, likken en bijten geleidelijk af.";
    } else if (track === "stress") {
      becauseText =
        "Omdat " +
        dogName +
        " last heeft van " +
        symptomsText +
        ", adviseren wij ons Anti Stress & Angst Supplement. De natuurlijke ingrediënten helpen het zenuwstelsel ondersteunen, waardoor " +
        dogName +
        " beter met dagelijkse prikkels om kan gaan en gemakkelijker ontspant.";
    }

    var timelineHtml = "";
    if (track === "stress") {
      timelineHtml =
        "<h2>Wat kun je de komende weken verwachten?</h2>" +
        "<p><strong>Week 1-2</strong><br>" +
        escapeHtml(dogName) +
        " reageert rustiger op dagelijkse stressprikkels en laat de eerste signalen van ontspanning zien.</p>" +
        "<p><strong>Week 3-4</strong><br>Je merkt dat " +
        escapeHtml(dogName) +
        " minder nerveus gedrag vertoont, sneller tot rust komt en beter omgaat met spannende situaties.</p>" +
        "<p><strong>Week 5-6</strong><br>" +
        escapeHtml(dogName) +
        " voelt zich zichtbaar meer ontspannen, slaapt beter en is emotioneel stabieler. De stress- of angstklachten waarvoor je bent begonnen zijn sterk verminderd of zelfs verdwenen.</p>";
    } else {
      timelineHtml =
        "<h2>Wat kun je de komende weken verwachten?</h2>" +
        "<p><strong>Week 1-2</strong><br>" +
        escapeHtml(dogName) +
        " voelt zich prettiger en heeft minder behoefte om te krabben, likken of bijten.</p>" +
        "<p><strong>Week 3-4</strong><br>De natuurlijke ingrediënten ondersteunen de huid van binnenuit. De huid van " +
        escapeHtml(dogName) +
        " wordt steeds rustiger en herstelt zich geleidelijk.</p>" +
        "<p><strong>Week 5-6</strong><br>De huid van " +
        escapeHtml(dogName) +
        " is weer gezond en in balans. De vacht oogt voller en glanzender en de jeukklachten waarvoor je bent begonnen zijn sterk verminderd of zelfs verdwenen.</p>";
    }

    return (
      '<div class="ppq-print-quiz-sheet ppq-print-quiz-sheet--plan">' +
      "<h1>Persoonlijk verbeterplan voor " +
      escapeHtml(dogName) +
      "</h1>" +
      '<p class="ppq-print-quiz-sheet__meta">Speciaal opgesteld voor <strong>' +
      escapeHtml(customerName) +
      "</strong><br>Datum: " +
      escapeHtml(dateStr) +
      "</p>" +
      '<div class="ppq-print-quiz-sheet__body">' +
      "<h2>Jouw hond in één oogopslag</h2>" +
      '<table class="ppq-print-table"><tbody>' +
      "<tr><th>Naam</th><td>" +
      escapeHtml(dogName) +
      "</td></tr>" +
      "<tr><th>Geslacht</th><td>" +
      escapeHtml(data.gender || "—") +
      "</td></tr>" +
      "<tr><th>Leeftijd</th><td>" +
      escapeHtml(data.age || "—") +
      " jaar</td></tr>" +
      "<tr><th>Gewicht</th><td>" +
      escapeHtml(data.weight || "—") +
      " kg</td></tr>" +
      "<tr><th>Voeding</th><td>" +
      escapeHtml(data.food || "—") +
      "</td></tr>" +
      "<tr><th>Activiteitsniveau</th><td>" +
      escapeHtml(activity) +
      "</td></tr>" +
      "<tr><th>Leefomgeving</th><td>" +
      escapeHtml(data.environment || "—") +
      "</td></tr>" +
      "</tbody></table>" +
      "<h2>Geselecteerde klachten</h2>" +
      "<p>" +
      escapeHtml(symptomsText) +
      "</p>" +
      "<h2>Onze analyse</h2>" +
      "<p>Op basis van jouw antwoorden zien we dat " +
      escapeHtml(dogName) +
      " momenteel last heeft van:</p>" +
      "<p><strong>" +
      escapeHtml(symptomsText) +
      "</strong></p>" +
      "<p>Deze klachten komen vaak samen voor en kunnen een grote invloed hebben op het dagelijkse welzijn van je hond.</p>" +
      "<p>Gelukkig zijn dit precies de klachten waarvoor ons supplement is ontwikkeld.</p>" +
      "<h2>Ons advies voor " +
      escapeHtml(dogName) +
      "</h2>" +
      "<p><strong>Aanbevolen product</strong><br>" +
      escapeHtml(productTitle) +
      "</p>" +
      "<p><strong>Waarom adviseren wij dit product?</strong><br>" +
      escapeHtml(becauseText) +
      "</p>" +
      "<h2>Zo gebruik je het product</h2>" +
      "<p><strong>Dagelijkse dosering</strong><br>" +
      escapeHtml(dosage) +
      "</p>" +
      "<p>Geef de chews iedere dag rond hetzelfde tijdstip.<br>Je kunt ze rechtstreeks als snack geven of mengen door de voeding.<br>Gebruik het supplement minimaal 6 weken voor het beste resultaat.</p>" +
      timelineHtml +
      "<h2>60 dagen niet goed, geld terug garantie</h2>" +
      "<p>Wij geloven in onze supplementen.<br>Daarom kun je " +
      escapeHtml(productTitle) +
      " 60 dagen volledig risicoloos proberen.</p>" +
      "<p>Zie je binnen 60 dagen geen merkbaar resultaat bij " +
      escapeHtml(dogName) +
      "?<br>Dan krijg je het volledige aankoopbedrag terug.<br>Je hoeft het product niet eens retour te sturen.</p>" +
      "<h2>Bespaar met een abonnement</h2>" +
      "<p>Wil je " +
      escapeHtml(dogName) +
      " langdurig ondersteunen?<br>Kies dan voor een abonnement en profiteer van extra voordelen:</p>" +
      "<ul class='ppq-print-list'>" +
      "<li>Altijd 10% extra korting</li>" +
      "<li>Zelf bepalen hoeveel potten je wilt ontvangen</li>" +
      "<li>Zelf kiezen hoe vaak je een nieuwe levering wilt ontvangen</li>" +
      "<li>Op ieder moment eenvoudig wijzigen of stopzetten</li>" +
      "<li>Exclusieve 1 op 1 begeleiding van een JC Pets specialist tijdens het hele traject</li>" +
      "</ul>" +
      "<h2>Klaar om " +
      escapeHtml(dogName) +
      " te helpen?</h2>" +
      "<p>Geef " +
      escapeHtml(dogName) +
      " vandaag nog de ondersteuning die hij of zij verdient.<br><strong>Bestel " +
      escapeHtml(productTitle) +
      "</strong></p>" +
      "</div></div>"
    );
  }

  function printQuizSummary(root) {
    var html = buildPrintSummaryHtml(root);
    var wrapper = document.createElement("div");
    wrapper.innerHTML = html.trim();
    var sheet = wrapper.firstElementChild;
    if (!sheet || !sheet.classList || !sheet.classList.contains("ppq-print-quiz-sheet")) {
      return;
    }

    sheet.setAttribute(
      "style",
      [
        "position:fixed",
        "left:0",
        "top:0",
        "right:0",
        "width:100%",
        "max-height:100vh",
        "overflow:auto",
        "box-sizing:border-box",
        "margin:0",
        "padding:16px 20px",
        "background:#fff",
        "color:#111",
        "font-family:system-ui,-apple-system,Segoe UI,Roboto,sans-serif",
        "font-size:12px",
        "line-height:1.35",
        "z-index:2147483646",
        "visibility:visible",
        "-webkit-print-color-adjust:exact",
        "print-color-adjust:exact",
      ].join(";")
    );

    document.body.appendChild(sheet);
    document.body.classList.add("ppq-print-quiz");

    function cleanup() {
      document.body.classList.remove("ppq-print-quiz");
      if (sheet.parentNode) sheet.parentNode.removeChild(sheet);
      sheet.removeAttribute("style");
      window.removeEventListener("afterprint", cleanup);
    }

    window.addEventListener("afterprint", cleanup);
    window.print();
    setTimeout(cleanup, 2500);
  }

  function init(root) {
    var overlay = qs(root, "[data-ppq-overlay]");
    if (!overlay) return;
    if (root.__ppqBound) return;
    root.__ppqBound = true;

    if (root.parentNode && root.parentNode !== document.body) {
      document.body.appendChild(root);
    }

    var heroPopup = qs(root, "[data-ppq-hero-popup]");
    var heroCloseBtn = qs(root, "[data-ppq-hero-close]");
    var heroBackdrop = qs(root, "[data-ppq-hero-backdrop]");
    var openBtn = qs(root, "[data-ppq-open]");
    var closeBtn = qs(root, "[data-ppq-close]");
    var cardEl = qs(root, "[data-ppq-card]");
    var steps = qsa(root, ".ppq-step[data-ppq-step]");
    var metaTotal = cardEl && cardEl.getAttribute("data-ppq-step-total");
    var parsedMeta = metaTotal ? parseInt(metaTotal, 10) : NaN;
    var totalSteps =
      !isNaN(parsedMeta) && parsedMeta > 0 ? parsedMeta : steps.length;
    if (!totalSteps || totalSteps < 1) {
      totalSteps = 5;
    }

    var stepLabel = qs(root, "[data-ppq-step-num]");
    var sectionLabel = qs(root, "[data-ppq-section-label]");
    var btnBack = qs(root, "[data-ppq-back]");
    var btnNextList = qsa(root, "[data-ppq-next]");
    var errEl = qs(root, "[data-ppq-error]");
    var productMap = parseProductMap(root);

    var current = 1;

    function setBodyScroll(lock) {
      if (lock) document.body.classList.add("ppq-no-scroll");
      else document.body.classList.remove("ppq-no-scroll");
    }

    function isHeroPopupOpen() {
      return heroPopup && heroPopup.classList.contains("is-open");
    }

    function isQuizOverlayOpen() {
      return overlay.classList.contains("is-open");
    }

    function syncBodyScroll() {
      setBodyScroll(isHeroPopupOpen() || isQuizOverlayOpen());
    }

    function openHeroPopup() {
      if (!heroPopup) return;
      heroPopup.classList.add("is-open");
      heroPopup.setAttribute("aria-hidden", "false");
      syncBodyScroll();
    }

    function closeHeroPopup() {
      if (!heroPopup) return;
      heroPopup.classList.remove("is-open");
      heroPopup.setAttribute("aria-hidden", "true");
      syncBodyScroll();
    }

    function showError(msg) {
      if (!errEl) return;
      errEl.textContent = msg || "";
      errEl.hidden = !msg;
    }

    function setStep(n) {
      current = Math.max(1, Math.min(totalSteps, n));
      steps.forEach(function (el) {
        var s = parseInt(el.getAttribute("data-ppq-step"), 10);
        el.classList.toggle("is-active", s === current);
      });
      var progressCard = cardEl || qs(root, "[data-ppq-card]");
      if (progressCard && totalSteps > 0) {
        var fr = Math.min(1, Math.max(0, current / totalSteps));
        progressCard.style.setProperty("--ppq-progress-fr", String(fr));
      }
      if (stepLabel) {
        var stepPrefix = (root.getAttribute("data-ppq-step-prefix") || "Stap").toUpperCase();
        var stepOf = (root.getAttribute("data-ppq-step-of") || "van").toUpperCase();
        stepLabel.textContent = stepPrefix + " " + current + " " + stepOf + " " + totalSteps;
      }
      var active = steps.find(function (el) {
        return parseInt(el.getAttribute("data-ppq-step"), 10) === current;
      });
      if (sectionLabel && active) {
        sectionLabel.textContent = active.getAttribute("data-ppq-section") || "";
      }
      var card = qs(root, "[data-ppq-card]");
      if (card) {
        card.setAttribute("data-active-step", String(current));
      }
      if (current === 1) {
        refreshSymptomPanels(root);
      }
      if (btnNextList.length) {
        var isLast = current === totalSteps;
        btnNextList.forEach(function (btn) {
          btn.disabled = false;
          if (isLast) {
            btn.textContent =
              root.getAttribute("data-ppq-done-label") || "Sluiten";
          } else if (current === 4) {
            btn.textContent =
              root.getAttribute("data-ppq-submit-label") ||
              "Maak nu mijn plan";
          } else {
            btn.textContent = root.getAttribute("data-ppq-next-label") || "Volgende →";
          }
        });
      }
      showError("");
    }

    function validate(step) {
      if (step === 1) {
        if (!symptomSelectedChips(root).length) {
          return root.getAttribute("data-ppq-err-step1") || "Selecteer minimaal één symptoom.";
        }
      }
      if (step === 2) {
        var name = qs(root, "[data-ppq-dog-name]");
        if (name && !name.value.trim()) {
          return root.getAttribute("data-ppq-err-step2") || "Voer de naam van je hond in.";
        }
        var gender = qs(root, ".ppq-gender__btn.is-selected");
        if (!gender) {
          return root.getAttribute("data-ppq-err-step2") || "Selecteer het geslacht.";
        }
      }
      if (step === 3) {
        var food = qs(root, "[data-ppq-food]");
        if (food && !food.value) {
          return root.getAttribute("data-ppq-err-step3") || "Selecteer een voedingstype.";
        }
        var env = qs(root, ".ppq-env__btn.is-selected");
        if (!env) {
          return root.getAttribute("data-ppq-err-step3") || "Selecteer de leefomgeving.";
        }
      }
      if (step === 4) {
        var fn = qs(root, "[data-ppq-first]");
        var ln = qs(root, "[data-ppq-last]");
        var em = qs(root, "[data-ppq-email]");
        if (fn && !fn.value.trim()) {
          return root.getAttribute("data-ppq-err-step4") || "Voer je voornaam in.";
        }
        if (ln && !ln.value.trim()) {
          return root.getAttribute("data-ppq-err-step4") || "Voer je achternaam in.";
        }
        if (em && !em.value.trim()) {
          return root.getAttribute("data-ppq-err-step4") || "Voer je e-mailadres in.";
        }
        var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (em && !re.test(em.value.trim())) {
          return root.getAttribute("data-ppq-err-step4") || "Voer een geldig e-mailadres in.";
        }
      }
      return "";
    }

    function openOverlay() {
      closeHeroPopup();
      overlay.classList.add("is-open");
      overlay.setAttribute("aria-hidden", "false");
      syncBodyScroll();
      closePopovers(overlay);
      resetQuiz(root, overlay, productMap);
      setStep(1);
      var focus = qs(overlay, "button, [href], input, select, textarea, [tabindex]:not([tabindex='-1'])");
      if (focus) focus.focus();
    }

    function closeOverlay() {
      overlay.classList.remove("is-open");
      overlay.setAttribute("aria-hidden", "true");
      syncBodyScroll();
      closePopovers(overlay);
    }

    if (root.hasAttribute("data-ppq-direct-open")) {
      setTimeout(openOverlay, 150);
    } else if (heroPopup && !root.hasAttribute("data-ppq-hero-no-autoshow")) {
      var delayRaw = root.getAttribute("data-ppq-hero-delay");
      var delayMs = delayRaw ? parseInt(delayRaw, 10) : 3500;
      if (isNaN(delayMs) || delayMs < 0) delayMs = 3500;
      setTimeout(openHeroPopup, delayMs);
    }

    if (heroCloseBtn) {
      heroCloseBtn.addEventListener("click", closeHeroPopup);
    }
    if (heroBackdrop) {
      heroBackdrop.addEventListener("click", closeHeroPopup);
    }

    if (openBtn) {
      openBtn.addEventListener("click", function (e) {
        e.preventDefault();
        openOverlay();
      });
    }
    if (closeBtn) {
      closeBtn.addEventListener("click", function () {
        resetQuiz(root, overlay, productMap);
        closeOverlay();
      });
    }

    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) {
        resetQuiz(root, overlay, productMap);
        closeOverlay();
      }
    });

    overlay.addEventListener("click", function (e) {
      if (e.target.closest("[data-ppq-info]") || e.target.closest("[data-ppq-popover]")) return;
      closePopovers(overlay);
    });

    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      if (isHeroPopupOpen()) {
        closeHeroPopup();
        e.preventDefault();
        return;
      }
      if (!isQuizOverlayOpen()) return;
      var openPop = qs(overlay, "[data-ppq-popover]:not([hidden])");
      if (openPop) {
        closePopovers(overlay);
        e.preventDefault();
        return;
      }
      resetQuiz(root, overlay, productMap);
      closeOverlay();
    });

    root.addEventListener("keydown", function (e) {
      if (e.key !== "Enter" && e.key !== " ") return;
      var pick = e.target.closest("[data-ppq-pick-track]");
      if (!pick || !root.contains(pick)) return;
      if (pick.tagName === "BUTTON") return;
      if (e.target.closest("[data-ppq-info]")) return;
      if (e.key === " ") e.preventDefault();
      var tr = pick.getAttribute("data-ppq-pick-track");
      setSelectedTrack(root, overlay, tr);
    });

    root.addEventListener("click", function (e) {
      var pick = e.target.closest("[data-ppq-pick-track]");
      if (pick && root.contains(pick)) {
        if (e.target.closest("[data-ppq-info]")) return;
        var tr = pick.getAttribute("data-ppq-pick-track");
        setSelectedTrack(root, overlay, tr);
        return;
      }

      var chip = e.target.closest(".ppq-chip--opt");
      if (!chip || !chip.closest('[data-ppq-step="1"]')) return;
      if (!root.contains(chip)) return;
      chip.classList.toggle("is-selected");
    });

    qsa(overlay, "[data-ppq-info]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.stopPropagation();
        togglePopover(overlay, btn);
      });
    });

    bindPopoverHover(overlay);

    var onPopoverReflow = function () {
      repositionOpenPopover(overlay);
    };
    overlay.addEventListener("scroll", onPopoverReflow, true);
    window.addEventListener("resize", onPopoverReflow);
    window.addEventListener("scroll", onPopoverReflow, true);

    qsa(root, ".ppq-gender__btn").forEach(function (btn) {
      btn.addEventListener("click", function () {
        qsa(root, ".ppq-gender__btn").forEach(function (b) {
          b.classList.remove("is-selected");
          b.setAttribute("aria-pressed", "false");
        });
        btn.classList.add("is-selected");
        btn.setAttribute("aria-pressed", "true");
      });
    });

    qsa(root, ".ppq-env__btn").forEach(function (btn) {
      btn.addEventListener("click", function () {
        qsa(root, ".ppq-env__btn").forEach(function (b) {
          b.classList.remove("is-selected");
        });
        btn.classList.add("is-selected");
      });
    });

    var emailPdfBtn = qs(root, "[data-ppq-email-pdf]");
    if (emailPdfBtn) {
      emailPdfBtn.addEventListener("click", function () {
        var status = qs(root, "[data-ppq-email-status]");
        submitQuizData(root, true).then(function () {
          if (status) {
            status.textContent =
              root.getAttribute("data-ppq-email-sent-label") ||
              "Plan verzonden naar je e-mail";
            status.hidden = false;
          }
        });
      });
    }

    var pdfBtn = qs(root, "[data-ppq-pdf]");
    if (pdfBtn) {
      pdfBtn.addEventListener("click", function (e) {
        var href = pdfBtn.getAttribute("data-href");
        if (href) {
          window.open(href, "_blank", "noopener");
          return;
        }
        e.preventDefault();
        printQuizSummary(root);
      });
    }

    function fillResultSummary() {
      var because = qs(root, "[data-ppq-result-because]");
      if (!because) return;
      var names = symptomSelectedChips(root)
        .map(function (c) {
          return c.getAttribute("data-label") || "";
        })
        .filter(Boolean);
      var dog = qs(root, "[data-ppq-dog-name]");
      var dogName = dog && dog.value.trim() ? dog.value.trim() : "je hond";
      var track = root.getAttribute("data-ppq-selected-track");
      var symptomsText = names.length ? names.join(", ") : "";
      var text = "";

      if (track === "skin" && symptomsText) {
        text =
          "Omdat " +
          dogName +
          " regelmatig last heeft van " +
          symptomsText +
          ", adviseren wij ons Anti Jeuk Supplement voor gerichte huid- en jeukondersteuning.";
      } else if (track === "stress" && symptomsText) {
        text =
          "Omdat " +
          dogName +
          " last heeft van " +
          symptomsText +
          ", adviseren wij ons Anti Stress & Angst Supplement voor kalmerende ondersteuning.";
      } else {
        text = because.getAttribute("data-default") || "";
      }

      because.textContent = text;
      updateResultUsps(root);

      var emailStatus = qs(root, "[data-ppq-email-status]");
      if (emailStatus) {
        if (root.getAttribute("data-ppq-email-sent") === "1") {
          emailStatus.textContent =
            root.getAttribute("data-ppq-email-sent-label") ||
            "Plan verzonden naar je e-mail";
          emailStatus.hidden = false;
        } else {
          emailStatus.hidden = true;
          emailStatus.textContent = "";
        }
      }
    }

    if (btnBack) {
      btnBack.addEventListener("click", function () {
        if (current === 1) {
          resetQuiz(root, overlay, productMap);
          closeOverlay();
          return;
        }
        if (current > 1) setStep(current - 1);
      });
    }

    if (btnNextList.length) {
      btnNextList.forEach(function (btnNext) {
        btnNext.addEventListener("click", function () {
          if (current === totalSteps) {
            resetQuiz(root, overlay, productMap);
            closeOverlay();
            return;
          }
          var err = validate(current);
          if (err) {
            showError(err);
            return;
          }
          if (current === 4) {
            applyRecommendation(root, productMap);
            fillResultSummary();
            submitQuizData(root);
          }
          setStep(current + 1);
        });
      });
    }

    resetQuiz(root, overlay, productMap);
    setStep(1);
  }

  function mountAllPpqRoots() {
    qsa(document, "[data-ppq-root]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", mountAllPpqRoots);
  } else {
    mountAllPpqRoots();
  }

  document.addEventListener("shopify:section:load", function (evt) {
    qsa(evt.target, "[data-ppq-root]").forEach(function (r) {
      try {
        delete r.__ppqBound;
      } catch (e) {
        r.__ppqBound = undefined;
      }
      init(r);
    });
  });
})();
